import { Component, inject, NgZone, OnInit,  } from '@angular/core';
import { IonApp, IonCardContent, IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonMenuToggle, IonRouterOutlet, IonSplitPane,  IonToggle,  Platform } from '@ionic/angular/standalone';
//import { Storage } from '@ionic/storage-angular';
import { StorageService } from './providers/storage.service';
import { RestService } from './providers/rest.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { VERSION } from './providers/config';
import { addIcons } from 'ionicons';
import {clipboardOutline , logOutOutline, peopleOutline, person, personOutline, settings, videocam, videocamOutline, bookOutline, chevronForwardOutline, footballOutline, diamondOutline, shareOutline, informationCircleOutline, mail, mailOutline, calendarOutline, mailOpenOutline } from 'ionicons/icons';
import { Device } from '@capacitor/device';
// import { Keyboard } from '@capacitor/keyboard';
// import { QRCodeComponent } from 'angularx-qrcode';
import { HelperService } from './providers/helper.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { ActionPerformed, LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications';
import { PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
// import { BackgroundRunner } from '@capacitor/background-runner';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { AlertService } from './providers/alert-service.service';
// import { BackgroundTask } from '@capawesome/capacitor-background-task';
// import {BackgroundFetch} from '@transistorsoft/capacitor-background-fetch';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    imports: [ IonApp, IonRouterOutlet, IonList, IonListHeader, IonMenu, IonSplitPane, IonMenuToggle, IonItem, IonIcon, IonLabel, IonContent, IonCardContent, IonToggle, FormsModule]
})
export class AppComponent implements OnInit{
  private email :string='';
  private internet = false;
  private serviceTimer: any;
  private password: string='';
  private num:number = 1;
  private latestNotifi:any = '';
  private registerTypes = {
          types: [
            {
              id: 'open_video',
              actions: [
                {
                  id:'0',
                  title: this.storage.translation.openVideo_t,
                  input: false
                },
                {
                id: '1',
                title: this.storage.translation.later_t,
                input: false
                }
              ]
            },
            {
              id: 'open_challenge',
              actions: [
                {
                  id:'0',
                  title: this.storage.translation.openChall_t,
                  input: false
                },
                {
                id: '1',
                title: this.storage.translation.later_t,
                input: false
                }
              ]
            },
            {
              id: 'discard_message',
              actions: [
                {
                id: '0',
                title: this.storage.translation.later_t,
                input: false
                }
              ]
            }
          ]
        };
  private taskId: any ;
  private BGtimer: any;

  // childData: ActivatedRoute = inject(ActivatedRoute);
  // private id: string | null = null;
  
 
  constructor(
    //private storageAngular: Storage,
    public storage: StorageService,
    private router: Router,
    private rest:RestService,
    private helper: HelperService,
    private alert: AlertService,
    private zone: NgZone
     
    ) {
      
      addIcons({clipboardOutline,videocamOutline,chevronForwardOutline,diamondOutline,peopleOutline,personOutline,footballOutline,bookOutline,logOutOutline, shareOutline, informationCircleOutline, mailOutline, calendarOutline, mailOpenOutline, person});
      // this.id = String(this.childData.snapshot.paramMap.get('id'));
      console.log('start appcomponents ');
      document.body.setAttribute('data-theme', 'light');
      document.body.classList.toggle('dark', false);
      // Keyboard.addListener("keyboardDidShow", () => {
      //   console.log('Keyboard is shown');
      //   if (document.activeElement) {
      //     document.activeElement.scrollIntoView({behavior: "smooth", block: "center"});
      //   }
      // });
      this.initializeApp().then(async() => {
        console.log('App initialized');
        this.start();
      });
    }
    // backgroundTimer(){
    //   this.BGtimer = setTimeout(() => {
    //     console.log('background timer: ', (new Date()).toLocaleTimeString());
    //     this.helper.notification({
    //       title: "Background timer",
    //       body: "background timer test @ "+ (new Date()),
    //     });
    //     this.backgroundTimer();
    //   }, 1000000);
    // }

    async initializeApp() {
      await this.getDevice();
      App.addListener('appStateChange', async (state) => {
        console.log('App state changed ', (new Date()).toLocaleTimeString(),': ', JSON.stringify(state));
          if(!state.isActive){
            await this.getNewMessages();
            
          }
        // this.helper.toastBottom('App state changed: ' + JSON.stringify(state), 3000);
        // this.alert.info('App state changed: ' + JSON.stringify(state));
        if(!state.isActive){
          // console.log('BackgroundFetch start');
          // this.initBackgroundFetch();
          // BackgroundFetch.start();
        }
        else{
          // BackgroundFetch.stop('com.practice.video.app.background');
          // console.log('BackgroundFetch stop');

        }
      // Run your code...
      // Finish the background task as soon as everything is done.
      // BackgroundTask.finish({ taskId });
        // if(!state.isActive){
        //   confirm('App is in background. Do you want to run background task?');
        //   this.taskId = BackgroundTask.beforeExit(async () => {
        //   this.backgroundTimer();
        //   });
        // }
        // else{
        //   BackgroundTask.finish({ taskId: this.taskId });
        //   clearTimeout(this.BGtimer);
        // }
      // Run your code...
      // Finish the background task as soon as everything is done.
      // BackgroundTask.finish({ taskId });
  

      });
      // if(this.storage.device.operatingSystem === 'android' || this.storage.device.operatingSystem === 'ios'){
      if(this.storage.device.platform !== 'web'){

        // const status = await BackgroundFetch.configure(
        //   {
        //     minimumFetchInterval: 20, // minutes
        //     stopOnTerminate: false,
        //     startOnBoot: true,
        //     enableHeadless: false,
        //   },
        //   async (taskId: string) => {
        //     // <-- Event callback
        //     console.log("[BackgroundFetch] Event received:", taskId);
        //     // Perform your work here...

        //     LocalNotifications.schedule({
        //       notifications: [{
        //         id: 1,
        //         title: "BackgroundFetch",
        //         body: "Background task executed at " + new Date().toLocaleTimeString(),
        //         actionTypeId: 'open_video',
        //       }]
        //     });
        //     BackgroundFetch.finish(taskId);
        //   },
        //   async (taskId: string) => {
        //     // <-- Timeout callback
        //     console.log("[BackgroundFetch] TIMEOUT:", taskId);
        //     BackgroundFetch.finish(taskId);
        //   }
        // );
        // console.log("[BackgroundFetch] configure status:", status);

        // BackgroundFetch.scheduleTask({
        //   taskId: "com.practice.video.app.bg-task",
        //   delay: 900000, // milliseconds
        //   periodic: true,
        //   forceAlarmManager: true,
        //   requiredNetworkType: BackgroundFetch.NETWORK_TYPE_ANY,
        // });
        // BackgroundFetch.start();
        // BackgroundRunner.checkPermissions().then(result => {
        //   console.log('BackgroundRunner permission status: ', JSON.stringify(result));
        //   if (result.notifications === 'granted') {
        //     console.log('BackgroundRunner permission granted');
                
        //     BackgroundRunner.requestPermissions({apis:['notifications']}).then(async result => {
        //       console.log('BackgroundRunner permission request result: ', JSON.stringify(result));
             
        //       if (result.notifications === 'granted' ) {
        //         console.log('BackgroundRunner permission granted');
        //         BackgroundRunner.dispatchEvent({
        //           label: 'com.practice.video.app.background',
        //           event: 'backGroundScheduler',
        //           details: {},
        //         });   
        //       }
        //       else{
        //         BackgroundRunner.addListener("backgroundRunnerNotificationReceived", (event) => {
        //         console.log('BackgroundRunner notification received: ', JSON.stringify(event));
        //         });
        //           BackgroundRunner.dispatchEvent({
        //           label: 'com.practice.video.app.background',
        //           event: 'backgroundScheduler',
        //           details: {},
        //         });   
        //       }
        //       // this.helper.toastMid('BackgroundRunner notification received: ' + JSON.stringify(event), 3000)

        //     });
        //  }
        // });
        
        // BackgroundRunner.removeNotificationListeners().then(async () => {
          
        //   const results = await BackgroundRunner.dispatchEvent({
        //     label: 'com.capacitor.background.task',
        //     event: 'testEvent',
        //     details: {}
        //   });
          

        // }).catch(err => {
        //   console.error('Error setting up BackgroundRunner listeners: ', err);
        // });


        LocalNotifications.checkPermissions().then(result => {
          console.log('LocalNotifications permission status: ', result);
          if (result.display !== 'granted') {
            console.log('Requesting LocalNotifications permission...');
            LocalNotifications.requestPermissions().then(result => {
              if (result.display === 'granted') {
                console.log('LocalNotifications permission granted');
                LocalNotifications.registerActionTypes(this.registerTypes);
                // this.helper.notification({
                //   title: "Notifi now:"+ this.num,
                //   body: "test @fter "+ this.num +' vid=66',
                //   id: Math.ceil(Math.random() * 100), // any random int
                //   scheduleAt: new Date(Date.now() + (100000 )) , //generate dayly scanning schedule
                //   actionTypeId: 'open_video',
                // });
                LocalNotifications.addListener('localNotificationReceived', (notification) => {
                  console.log('Local notification received: ',JSON.stringify(notification));
                  this.latestNotifi = notification;
                  let param = this.latestNotifi.body.search('vid=');
                  if(param !== -1){
                    this.latestNotifi['videoId'] = this.latestNotifi.body.split('vid=')[1].toString();

                  }
                  else if(this.latestNotifi.body.search('cha=') !== -1){
                    this.latestNotifi['challengeId'] = this.latestNotifi.body.split('cha=')[1].toString();
                  }
                  else{
                    console.log('no video or challenge id found in notification');
                  }
                  // this.helper.toastMid('Local notification received: ' + JSON.stringify(notification), 3000);
                  // this.alert.info('Local notification received: ' + JSON.stringify(notification));
                  // this.num++;
                  // if(this.num%2 === 0){
                  //   LocalNotifications.cancel({ notifications: [{ id: notification.id }] }).then(() => {
                  //     console.log('Notification cancelled: ', notification.id);
                  //   }).catch(err => {
                  //     console.error('Error cancelling notification: ', err);
                  //   });
                  // }
                  
                  //   this.helper.notification({
                  //     title: "Notifi now:"+ this.num,
                  //     body: "test @fter "+ this.num,
                  //     id: Math.ceil(Math.random() * 100), // any random int
                  //     scheduleAt: new Date(Date.now() + (100000 )) ,
                  //     actionTypeId: 'open_video',
                  //   });      
                    // this.helper.toastBottom('Notification received: ' + JSON.stringify(notification), 3000);
                  
                });

                LocalNotifications.addListener('localNotificationActionPerformed', (notificationAction: ActionPerformed) => {
                  // this.openVideo(8);
                  // this.router.navigateByUrl('/tabs/tab3');
                  console.log('Local notification action performed: ',JSON.stringify(notificationAction));
                  //if vid=  or cha= then open video or challenge

                  // this.storage.selectedVideo = this.storage.practiceVideos[this.num];
                  // this.alert.areUsure({title: 'Notification action performed: ' + JSON.stringify(notificationAction), message:'add some code here' });
                  if(this.latestNotifi.videoId){
                    this.router.navigateByUrl('/vid='+this.latestNotifi.videoId);
                  }
                  else if(this.latestNotifi.challengeId){
                      this.router.navigateByUrl('/cha='+this.latestNotifi.challengeId);
                  }
                  // this.router.navigateByUrl('/vid=66');

                  // this.helper.toastMid('Notification action performed: ' + notificationAction, 3000);
                });

              } else {
                console.log('LocalNotifications permission denied');
              }
            });
          }
        });
        
      
      console.log('Localnotifications actions registered');

      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {    
          this.zone.run(() => {

              console.log('App opened with URL: ', event.url);
              const slug = event.url.search('https://app.treeniappi.com/');
              if (slug!==-1) {
                this.storage.param = event.url.split('https://app.treeniappi.com/')[1];
                console.log('Extracted slug: ', this.storage.param); 
                this.storage.page = '/app/login';
                this.router.navigateByUrl('/app/login/'+this.storage.param);

              }
              // If no match, do nothing - let regular routing
              // logic take over
          });
      });
      // }
      // this.initBackgroundFetch();
  PushNotifications.requestPermissions().then(async (permission) => {

      if (permission.receive == 'granted') {

        await PushNotifications.register();

      } else {

        // No permission to push granted

      }

    });

    PushNotifications.addListener('registration', async (token:Token) => {

      console.log("token", token);

      if (token)

        this.storage.set('push-notification-token', token.value);

      });
    PushNotifications.addListener('registrationError', (error: any) => {

      console.log('Error', JSON.stringify(error));

    });
        // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        // alert('Push received: ' + JSON.stringify(notification));
        console.log('Push received: ', JSON.stringify(notification));
        if(notification.data && (notification.data.weekly)){
          let lastLogin = (new Date(this.storage.get('last_login')).getTime());
          let now = (new Date()).getTime();
          if(now - lastLogin > 7*24*60*60*1000){
            console.log('Weekly notification triggered');
          }
          else{
            PushNotifications.removeDeliveredNotifications({ notifications: [notification] }).then(() => {
              console.log('Weekly notification dismissed');
            });
          }
        }
      }
    );

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {

      console.log("notification", notification);

      const data = notification.notification;

      console.log("data token data", data.data);
      if(data.data && (data.data.vid || data.data.cha)){
        if(data.data.vid){
          this.router.navigateByUrl('/vid='+data.data.vid);
        }
        else if(data.data.cha){
          this.router.navigateByUrl('/cha='+data.data.cha);
        }
      }

      //alert is functional
      //this.alert.info('Push notification action performed: ' + JSON.stringify(notification)); 

    });
    const getDeliveredNotifications = async () => {
      const notificationList = await PushNotifications.getDeliveredNotifications();
      console.log('delivered notifications', notificationList);
      //??
      //this.alert.info('Delivered notifications: ' + JSON.stringify(notificationList));
    };
  }

  // private async runTask(): Promise<void> {
  //   const taskDurationMs = 120000;
  //   const end = new Date().getTime() + taskDurationMs;
  //   while (new Date().getTime() < end) {
  //     const isAppActive = await this.isAppActive();
  //     if (isAppActive) {
  //       break;
  //     }
  //     console.log('Background task still active.');
  //     await this.runInnerTask();
  //   }
  // }

  // private async runInnerTask(): Promise<void> {
  //   const taskDurationMs = 5000;
  //   const end = new Date().getTime() + taskDurationMs;
  //   while (new Date().getTime() < end) {}
  // }

  // private async isAppActive(): Promise<boolean> {
  //   const currentState = await App.getState();
  //   return currentState.isActive;
  // }
//   async performBackgroundFetch() {
//   const result = await BackgroundRunner.dispatchEvent({
//     label: 'com.practice.video.app.background',
//     event: 'fetchTest',
//     details: {},
//   });
//   return result;
// };

// // Schedule a notification from background
// async scheduleBGNotification() {
//   await BackgroundRunner.dispatchEvent({
//     label: 'com.practice.video.app.background',
//     event: 'notificationTest',
//     details: {},
//   });
}

  start(){
  // this.getDevice();
    // if( this.storage.device.operatingSystem === 'android' || this.storage.device.operatingSystem === 'ios'){
  //    const addListeners = async () => {
  //       await PushNotifications.addListener('registration', token => {
  //         console.info('Registration token: ', token.value);
  //       });

  //   await PushNotifications.addListener('registrationError', err => {
  //     console.error('Registration error: ', err.error);
  //   });

  //   await PushNotifications.addListener('pushNotificationReceived', notification => {
  //     console.log('Push notification received: ', notification);
  //   });

  //   await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
  //     console.log('Push notification action performed', notification.actionId, notification.inputValue);
  //   });
  // }

  // const registerNotifications = async () => {
  //   let permStatus = await PushNotifications.checkPermissions();

  //   if (permStatus.receive === 'prompt') {
  //     permStatus = await PushNotifications.requestPermissions();
  //   }

  //   if (permStatus.receive !== 'granted') {
  //     throw new Error('User denied permissions!');
  //   }

  //   await PushNotifications.register();
  //}

  // const getDeliveredNotifications = async () => {
  //   const notificationList = await PushNotifications.getDeliveredNotifications();
  //   console.log('delivered notifications', notificationList);
  //   }
    if(this.storage.device.platform !== 'web'){
      StatusBar.setOverlaysWebView({ overlay: true });

      const setStatusBarStyleDark = async () => {
        await StatusBar.setStyle({ style: Style.Light });
      };

      const setStatusBarStyleLight = async () => {
        await StatusBar.setStyle({ style: Style.Light });
      };
    // }

        const showStatusBar = async () => {
          await StatusBar.show();
        };
    }   
  }
    roleChanged(){
      if(!this.storage.playerMode){
        this.storage.playerMode = false;
        this.storage.role = this.storage.role==='demo'?'demo': this.storage.user.role;
      }
      else{
        this.storage.playerMode = true;
        this.storage.role = this.storage.role==='demo'?'demo': 'player';

      }
      console.log('changed role: ', this.storage.role, 'player: ', this.storage.playerMode);
    }
    async getNewMessages(){
      if(this.storage.token){
        this.rest.getMyMessages().then(async (messages:any) => {
          console.log('Fetch my active messages: ', messages);
          await this.ifMessages(messages);
          await this.findNewMessages(messages);
        }).catch((err:any) => {
          console.log('Error fetching messages in background: ', err);
          this.rest.getAuthMessages({email: this.storage.email, password: this.storage.password}).then(async (messages:any) => {
            console.log('Fetch my auth active messages: ', messages);
            await this.ifMessages(messages);
            await this.findNewMessages(messages);  
          }).catch((err:any) => {
            console.log('Error fetching messages in background: ', err);
          });
        });
      }
      else{
        this.rest.getAuthMessages({email: this.storage.email, password: this.storage.password}).then(async (messages:any) => {
          console.log('Fetch active messages: ', messages);
          await this.ifMessages(messages);
          await this.findNewMessages(messages);  
        }).catch((err:any) => {
          console.log('Error fetching messages in background: ', err);
        });
      }
    }
    private async ifMessages(messages:any){
      let storagemessages = this.storage.get('messages');
      this.storage.messages = await JSON.parse(storagemessages);
      // console.log('Messages in storage: ', storagemessages);
      if(messages){
        
        if(!storagemessages || storagemessages.length === 0 || storagemessages === '[]' || storagemessages === null || storagemessages === undefined){
          // this.storage.set('messages', JSON.stringify(messages));
          // this.storage.messages = messages;
          this.storage.messages = {commonMessages:[], userMessages:[], teamCoachMessages:[], clubMessages:[], teamPlayerMessages:[]};
        }
      }
      else{
        return;
      }
      console.log('Current stored messages: ', this.storage.messages);
      // let tempClubMessages=[];
      // if(this.storage.messages.clubMessages && this.storage.messages.clubMessages.length > 0){
      //   for(let i=0; i< this.storage.messages.clubMessages.length; i++){
      //     for(let j=0; j< this.storage.messages.clubMessages[i].length; j++){
      //       tempClubMessages.push(this.storage.messages.clubMessages[i][j]);
      //     }
      //   }
      //   this.storage.messages.clubMessages = tempClubMessages;
      // }

      // let tempTeamCoachMessages=[];
      // if(this.storage.messages.teamCoachMessages && this.storage.messages.teamCoachMessages.length > 0){
      //   for(let i=0; i< this.storage.messages.teamCoachMessages.length; i++){
      //     for(let j=0; j< this.storage.messages.teamCoachMessages[i].length; j++){
      //       tempTeamCoachMessages.push(this.storage.messages.teamCoachMessages[i][j]);
      //     }
      //   }
      //   this.storage.messages.teamCoachMessages = tempTeamCoachMessages;
      // }
      // console.log('Current stored messages in single arrays: ', this.storage.messages);

    }
  
    async findNewMessages(messages:any){
      console.log('Finding new messages: ');
      if(messages === null || messages === undefined){
        this.storage.newMessages = [];
        console.log('no messages found');
        return;
      }
      let newMessages = messages;
      if(newMessages && newMessages.commonMessages && newMessages.commonMessages.length > 0){
        for(let i=0; i< newMessages.commonMessages.length; i++){
          for(let j=0; j< this.storage.messages.commonMessages.length; j++){
            if(newMessages.commonMessages[i].id === this.storage.messages.commonMessages[j].id){
              // console.log('message already exists: ', newMessages.commonMessages[i]);
              newMessages.commonMessages.splice(i,1);
              // console.log('message removed from new messages: ', newMessages.commonMessages[i]);
              i--;
              j = this.storage.messages.commonMessages.length;
            }
          }
        }
      }  
      if(newMessages && newMessages.userMessages && newMessages.userMessages.length > 0){
        for(let i=0; i< newMessages.userMessages.length; i++){
          for(let j=0; j< this.storage.messages.userMessages.length; j++){
            if(newMessages.userMessages[i].id === this.storage.messages.userMessages[j].id){
              newMessages.userMessages.splice(i,1);
              i--;
              j = this.storage.messages.userMessages.length;
            }
          }
        }
      }

      if(newMessages && newMessages.teamCoachMessages && newMessages.teamCoachMessages.length > 0){
        let tempMessages=[];
        for(let i=0; i< newMessages.teamCoachMessages.length; i++){
          for(let j=0; j< newMessages.teamCoachMessages[i].length; j++){
            tempMessages.push(newMessages.teamCoachMessages[i][j]);
          }
        }
        newMessages.teamCoachMessages = tempMessages;
        for(let i=0; i< newMessages.teamCoachMessages.length; i++){
          for(let j=0; j< this.storage.messages.teamCoachMessages.length; j++){
            if(newMessages.teamCoachMessages[i].id === this.storage.messages.teamCoachMessages[j].id){
              newMessages.teamCoachMessages.splice(i,1);
              i--;
              j = this.storage.messages.teamCoachMessages.length;
            }
          }
        }
      }

      if(newMessages && newMessages.clubMessages && newMessages.clubMessages.length > 0){
        let tempClubMessages=[];
        for(let i=0; i< newMessages.clubMessages.length; i++){
          for(let j=0; j< newMessages.clubMessages[i].length; j++){
            tempClubMessages.push(newMessages.clubMessages[i][j]);
          }
        }
        newMessages.clubMessages = tempClubMessages;
        for(let i=0; i< newMessages.clubMessages.length; i++){
          for(let j=0; j< this.storage.messages.clubMessages.length; j++){
            if(newMessages.clubMessages[i].id === this.storage.messages.clubMessages[j].id){
              newMessages.clubMessages.splice(i,1);
              i--;
              j = this.storage.messages.clubMessages.length;
            }
          }
        }
      }
      this.storage.newMessages = newMessages;
      // if(newMessages && newMessages.commonMessages && newMessages.commonMessages.length > 0){
      //   for(let i=0; i< newMessages.commonMessages.length; i++){
      //     this.storage.newMessages.push(newMessages.commonMessages[i]);
      //     this.storage.newMessages[this.storage.newMessages.length-1]['type'] = 'common';
      //   }
      // }
      // if(newMessages&& newMessages.userMessages && newMessages.userMessages.length > 0){
      //   for(let i=0; i< newMessages.userMessages.length; i++){
      //     this.storage.newMessages.push(newMessages.userMessages[i]);
      //     this.storage.newMessages[this.storage.newMessages.length-1]['type'] = 'user';
      //   }
      // }
      // if(newMessages && newMessages.teamMessages && newMessages.teamMessages.length > 0){
      //   for(let i=0; i< newMessages.teamMessages.length; i++){
      //     this.storage.newMessages.push(newMessages.teamMessages[i]);
      //     this.storage.newMessages[this.storage.newMessages.length-1]['type'] = 'team';
      //   }
      // }
      // if(newMessages && newMessages.clubMessages && newMessages.clubMessages.length > 0){
      //   for(let i=0; i< newMessages.clubMessages.length; i++){
      //     this.storage.newMessages.push(newMessages.clubMessages[i]);
      //     this.storage.newMessages[this.storage.newMessages.length-1]['type'] = 'club';
      //   }
      // }
      console.log('new messages: ', this.storage.newMessages);  
      if(this.storage.newMessages && (this.storage.newMessages.commonMessages.length > 0 || this.storage.newMessages.userMessages.length > 0 || this.storage.newMessages.teamCoachMessages.length > 0 || this.storage.newMessages.clubMessages.length > 0)){
        this.storage.alertReturn = '';
        await this.alert.message().then((res:any) => {
          
        });

      }

      
    }
  
  async ngOnInit() {
    console.log(' appcomponents init ');
    // If using a custom driver:
    // await this.storage.defineDriver(MyCustomDriver)

    //await this.storageAngular.create();
    // this.start();
    // this.storage.videoId = this.id;
    // this.storage.page = 'login';
   let timer = setTimeout(() => {
      if(this.storage.page === ''){
        this.router.navigateByUrl('/app/login/');
      }
    }, 3000);
    
    console.log('login: ', this.storage.login);
    this.email = this.storage.email.toUpperCase();
    let timer2 = setTimeout(() => {
      this.getNewMessages();
    }, 2000);
    // this.timerService();

  }
  timerService(){
    // console.log('timerService count: ', this.storage.timerServiceCounter,'ts: ', Date.now(),': ',new Date(), 'trainnhg done: ', this.storage.trainingDone);
    // let delay:any =this.storage.config.find( ({name}) => name === 'tra_d');
    // if(!delay)delay = 301;
    // else{delay = delay.data1}
    // console.log('delay: ', delay);
    // this.serviceTimer = setInterval(() => {
    //   this.storage.timerServiceCounter++;
    //   this.storage.trainingDone = false;
    //   clearInterval(this.serviceTimer);
    //   this.timerService();
    // }, delay*1000);
    

  }
  setVideos(){
    this.storage.page = 'admin';
    this.router.navigateByUrl('/app/admin');

  }
  usersPage(){
    this.storage.page = 'users';
    this.router.navigateByUrl('/app/users');
    // console.log(this.route.getCurrentNavigation());

  }
  teamPage(){
    this.storage.page = 'team';
    this.router.navigateByUrl('/app/team');
    // console.log(this.route.getCurrentNavigation());

  }
  lineupPage(){
    this.storage.page = 'lineup';
    this.router.navigateByUrl('/app/lineup');
  }
  clubsPage(){
    this.storage.page = 'clubs';
    this.router.navigateByUrl('/app/clubs');
    // console.log(this.route.getCurrentNavigation());

  }
  challengesPage(){
    this.storage.page = 'chalenges';
    this.router.navigateByUrl('/app/chalenges');
    // console.log(this.route.getCurrentNavigation());

  }
  userPage(){
    // this.rest.getMyUser().then((user: any) => {
      this.storage.selectedUser = this.storage.user;
      this.storage.page = '/user';
      this.router.navigateByUrl('/app/user');
  //   }).catch((err: any) => {
  //   console.log('Error: ', err);
  // });
  }
  translates(){
    this.rest.getTranslates().then((translates: any) => {
      console.log('translates: ', translates);
      this.storage.translates = translates;
      this.storage.page = 'translate';
      this.router.navigateByUrl('/app/translate');
    }).catch((err: any) => {
    console.log('Error: ', err);
  });
  }
  shareVideo(){
    this.storage.page = 'share';
    this.router.navigateByUrl('/app/share');
    // console.log(this.route.getCurrentNavigation());

  }
  postPage(){
  this.storage.page = 'post';
  this.router.navigateByUrl('/app/post');
  // console.log(this.route.getCurrentNavigation());
  }
  messagePage(){
  this.storage.page = 'message';
  this.router.navigateByUrl('/app/message');
  // console.log(this.route.getCurrentNavigation());
  }

  aboutPage(){
    this.storage.page = 'about';
    this.router.navigateByUrl('/app/about');
    // console.log(this.route.getCurrentNavigation());

  }
  logOut(){
    this.rest.logout();
    this.router.navigateByUrl('/app/login/');
    this.storage.page = '/logout';
    this.storage.login = false;
    // console.log(this.route.getCurrentNavigation());
    this.storage.myClub = null;
    this.storage.myTeam = null;
    this.storage.user = null;
    this.storage.selectedUser = null;
    this.storage.role = 'user';
    this.storage.playerMode = false;
    this.storage.messages = null;
    this.storage.newMessages = [];

  }
    calendarPage(){
    this.storage.page = 'calendar';
    this.router.navigateByUrl('/tabs/calendar');
    // console.log(this.route.getCurrentNavigation());
  }
 
  private async getDevice(){
    this.internet = false;
    await Device.getInfo().then(async(info:any) => {
      console.log('device info: ',info, 'operatingSystem: ', info.operatingSystem);
      this.storage.device = info;

    }
    ).catch((err:any) => {
      console.log('err: ',err);
    });
    await Device.getLanguageTag().then(async (lang:any) => {
      
      this.storage.lan = lang.value.slice(0,2);
      if(this.storage.lan ==='fi' ){}
      else {this.storage.lan = 'en';}
      this.storage.setTranslation(this.storage.lan);

      console.log('lang info: ',lang, 'lan_code: ', this.storage.lan);
      await this.rest.getMyTranslateByCode(lang.value.slice(0,2)).then(async(info:any) => {
      this.internet = true;
      this.storage.translate = info;
      }).catch((err:any) => {
        console.log('err get translate: ',err);
        this.internet = false;
        return;
      });
    }).catch((err:any) => {
      console.log('err: ',err);
    });
  }
  async scheduleNotification(){
    let options:ScheduleOptions={
      notifications:[
        {
          id:111,
          title:"reminder notification",
          body:"body test",
          largeBody:"large body test",
          summaryText: "summarytest..."
        }
      ]
    }
    try{
      await LocalNotifications.schedule(options)
    }
    catch(ex){
      alert(JSON.stringify(ex));
    }
  }
  //   public async openVideo(id:number){

  //   if(this.storage.is()){
  //     console.log('storage ok');
  //     let email = this.storage.get('email');
  //     if(typeof email === 'string' ){this.email = email;}
      
  //     let password = this.storage.get('password');
  //     if(typeof password === 'string'){this.password = password;}
  //     this.rest.login2(this.email, this.password).then(async (user:any) => {
  //       this.storage.set('last_login', Date.now().toString());
  //         console.log('storage-test: ',this.storage.get('email') );
  //         console.log('login2: ', user);
  //         this.storage.user = user.user;
  //         if(this.storage.user.level === 0 || null){this.storage.user.level = 1;}
  //         console.log('user level: ', this.storage.user.level);
  //         this.storage.coach = user.userData.coach;
  //         this.storage.player = user.userData.player;
  //         if(user.userData.myTeam) {this.storage.myTeam = user.user.last_team_id;}
  //         else{ if(user.userData.coach && user.userData.coach.length > 0)this.storage.myTeam = user.userData.coach[0].team_id;}
  //         if(user.userData.myClub) {this.storage.myClub = user.user.last_club_id;}
  //         else{ if(user.userData.coach && user.userData.coach.length > 0)this.storage.myClub = user.userData.coach[0].club_id;}
  //         this.storage.config = user.userData.configSet;
          
  //         this.storage.age = (new Date()).getFullYear() -  user.user.birthyear;
  //         this.setAgeClass(this.storage.age);
  //         await this.rest.getVideos().then(async (videos: any) => {
  //             // console.log('videos: ', videos.data);
  //             this.storage.practiceVideos = videos.data;
  //             for(let i=0; i< this.storage.practiceVideos.length; i++){
  //               if(this.storage.practiceVideos[i].id === id){
  //                 this.storage.selectedVideo = this.storage.practiceVideos[i];
  //                 i = this.storage.practiceVideos.length;
  //             }
  //           }

  //         });
          
  //       await this.helper.load.dismiss();
  //     }).catch( async err => {
  //       console.log('relogin failed');
  //       await this.helper.load.dismiss();
  //       return;
  //     });
  //   }

  //   this.storage.page = '/tabs/tab3';
    
  // }
  setAgeClass(age:number){
    this.storage.age = age;
    if(this.storage.age < 9){this.storage.ageClass = 5;}
    else if(this.storage.age < 11){this.storage.ageClass = 4;}
    else if(this.storage.age < 13){this.storage.ageClass = 3;}
    else if(this.storage.age < 17){this.storage.ageClass = 2;}
    else{this.storage.ageClass = 1;}
  }

}


